import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core';

import { Block } from '../Block';

const useStyles = makeStyles(() =>
    createStyles({
        buttonContainer: {
            display: 'flex',
            flexDirection: 'row',
        },
    }),
);

interface IButtonsContainerProps {
    children?: React.ReactNode;
    [key: string]: unknown;
}

export const ButtonsContainer: React.FC<IButtonsContainerProps> = ({
    children,
    ...rest
}) => {
    const classes = useStyles();

    return (
        <Block className={classes.buttonContainer} {...rest}>
            {children}
        </Block>
    );
};
